import { type ExpandedState, getCoreRowModel } from "@tanstack/react-table"
import type { FC } from "react"
import { useState } from "react"

import { useSourceChangeHistoryColumns } from "../hooks/useSourceChangeHistoryColumns"

import { SourceChangeRowDetails } from "./SourceChangeRowDetails"

import { AerosBaseTable } from "@/components/Tables/Aeros/components/AerosBaseTable"
import type { ProductSourceChangeEvent } from "@/graphql/codegen/graphql"

interface SourceChangeHistoryTableProps {
  data: ProductSourceChangeEvent[]
  loading?: boolean
}

export const SourceChangeHistoryTable: FC<SourceChangeHistoryTableProps> = ({ data, loading = false }) => {
  const [expanded, setExpanded] = useState<ExpandedState>({})
  const columns = useSourceChangeHistoryColumns()

  return (
    <AerosBaseTable
      features={{
        table: { stickyHeader: false },
        tanstackOptions: {
          data,
          columns,
          state: { expanded, isLoading: loading },
          onExpandedChange: setExpanded,
          getRowCanExpand: () => true,
          getCoreRowModel: getCoreRowModel(),
          getRowId: (sourceChange) => sourceChange.sourceChangeBatchId,
          renderExpandedContent: (row) => <SourceChangeRowDetails row={row} />,
        },
      }}
      slotProps={{ bodyCellExpanded: { className: "bg-primary-100" } }}
      noDataMessage='No source changes found'
    />
  )
}
